export default __webpack_public_path__ + "static/media/newspaper.e25c9951.svg";